import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './OrderStatus.scss';

const OrderStatus = ({ status, title, isFlush = false }) => (
  <div className={cx('order-status', { 'order-status--flush': isFlush })}>
    <span
      className={cx('order-status__icon', {
        [`order-status__icon--${status}`]: status
      })}
    />
    <h5 className="text-kilo bold order-status__title">{title}</h5>
  </div>
);

OrderStatus.propTypes = {
  isFlush: PropTypes.bool,
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default OrderStatus;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderStatus/OrderStatus.js